import BffApiService from '@/shared/bffApiService';

export const seonService = {
  getSession: async (): Promise<string | null> => {
    if (!window.seon) return null;

    try {
      const session = await window.seon.getSession({
        region: 'eu',
        silentMode: true,
        networkTimeoutMs: 3000,
        fieldTimeoutMs: 5000,
      });
      return session;
    } catch (e) {
      console.warn('[SEON] getSession failed:', e);
      return null;
    }
  },

  checkFraudEvent: async (actionType: 'login' | 'register'): Promise<void> => {
    const session = await seonService.getSession();

    if (!session) return;

    try {
      await BffApiService.sendSeonFraudEvent({ payload: { actionType, session } });
    } catch (e) {
      console.warn('[SEON] checkFraudEvent failed:', e);
    }
  },
};
